import { apiDelete, apiGet, apiPatch, apiPost } from './client';

export function listValuations() {
  return apiGet('/api/v1/valuations');
}

export function getValuation(publicId) {
  return apiGet(`/api/v1/valuations/${encodeURIComponent(publicId)}`);
}

export function createValuation({ name, inputs, status = 'draft' }) {
  return apiPost('/api/v1/valuations', { name, inputs, status });
}

export function updateValuation(publicId, patch) {
  return apiPatch(`/api/v1/valuations/${encodeURIComponent(publicId)}`, patch);
}

export function deleteValuation(publicId) {
  return apiDelete(`/api/v1/valuations/${encodeURIComponent(publicId)}`);
}
